<div class="flex flex-col h-screen">
  @if (!isLoading) {
  @if (authenticated) {
  <sn-main-nav class="flex"></sn-main-nav>
  <main class="flex-1 overflow-y-auto p-7">
    <router-outlet></router-outlet>
  </main>
  } @else {
  <div class="flex items-center justify-center h-full">
    <div class="text-center">
      <div class="mb-4">
        <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
      </div>
      <p class="text-gray-600">Redirecting to login...</p>
    </div>
  </div>
  }
  } @else {
  <div class="flex items-center justify-center h-full">
    <div class="text-center">
      <div class="mb-4">
        <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
      </div>
      <p class="text-gray-600">Loading application...</p>
    </div>
  </div>
  }
</div>

<app-spinner></app-spinner>